import React from 'react';
import PropTypes from 'prop-types';

export default function BackgroundColorContainer({ color, children }) {
  return (
    <div>
      <style>
        {`
        .ant-layout{
          background:${color};
        }
      `}
      </style>
      {children}
    </div>
  );
}

BackgroundColorContainer.propTypes = {
  children: PropTypes.any.isRequired,
  color: PropTypes.string.isRequired,
};
